import EventEmitter from "events";
import { Activities } from "src/modules/activity-log/activity";

export default function createActivityEmitter({
  noiseMeter,
  durationToSleep = 0,
  durationToAwake = 0,
  awakeMinimalVolume = 0
}) {
  const motionMinimalDuration = 2000;
  const awakeMinimalDuration = 2000;
  let activity = Activities.SLEEPING;
  let silenceStartDate = Date.now();
  let noiseStartDate = null;
  let motionStartDate = null;
  let vol = 0;
  let motionDelay = null;
  const emitter = new EventEmitter();

  function handleSilence(volume) {
    if (Date.now() - motionStartDate < motionMinimalDuration) return;
    if (
      activity === Activities.SLEEPING ||
      silenceStartDate + durationToSleep <= Date.now()
    ) {
      emitter.emit("update", { activity: Activities.SLEEPING, volume });
      activity !== Activities.SLEEPING &&
        emitter.emit("activity-change", Activities.SLEEPING);
    } else {
      emitter.emit("update", { activity: Activities.AWAKE, volume });
    }
  }

  function handleNoise(volume) {
    if (
      activity === Activities.AWAKE ||
      noiseStartDate + durationToAwake <= Date.now()
    ) {
      emitter.emit("update", { activity: Activities.AWAKE, volume });
      activity !== Activities.AWAKE &&
        emitter.emit("activity-change", Activities.AWAKE);
    } else {
      emitter.emit("update", { activity: Activities.SLEEPING, volume });
    }
  }

  function handleMotion() {
    motionStartDate = Date.now();
    if (activity === Activities.AWAKE && vol !== 0) return;
    if (
      activity === Activities.AWAKE &&
      Date.now() - motionDelay < awakeMinimalDuration
    ) {
      return;
    }
    motionDelay = null;
    activity !== Activities.MOTION &&
      emitter.emit("activity-change", Activities.MOTION);
  }

  function handleVolumeChange(volume) {
    if (!motionDelay) motionDelay = Date.now();
    vol = volume;
    if (volume <= awakeMinimalVolume) {
      if (silenceStartDate == null) {
        silenceStartDate = Date.now();
        noiseStartDate = null;
      }
      handleSilence(volume);
    } else {
      if (noiseStartDate == null) {
        noiseStartDate = Date.now();
        silenceStartDate = null;
      }
      handleNoise(volume);
    }
  }

  noiseMeter.on("change", handleVolumeChange);
  emitter.on("activity-change", (newActivity) => (activity = newActivity));

  return Object.assign(emitter, {
    destroy() {
      noiseMeter.off("change", handleVolumeChange);
    },
    getActivity() {
      return activity;
    },
    handleMotion
  });
}
